import isEmpty from 'lodash/isEmpty';

import { LANGUAGES } from '../constants';

export default function detectLanguageId(language) {
  const currentLanguage = LANGUAGES.find(item => item.name === language);

  if (!isEmpty(currentLanguage)) {
    return currentLanguage.id;
  }

  const englishLanguage = LANGUAGES.find(item => item.name === 'en');
  return englishLanguage.id;
}
